var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoyaltyBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loyaltyNavGradient",
    gradientTransform: "rotate(300)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    stopColor: "#F8A305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#F51504"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "navigation__loyalty-badge",
    d: "M12 2L14.4 4.1L17.6 3.8L18.3 7L21 9L19.8 12L21 15L18.3 17L17.6 20.2L14.4 19.9L12 22L9.6 19.9L6.4 20.2L5.7 17L3 15L4.2 12L3 9L5.7 7L6.4 3.8L9.6 4.1L12 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "navigation__loyalty-star",
    d: "M12 7.5L13.4 10.3L16.5 10.7L14.2 12.9L14.8 16L12 14.5L9.2 16L9.8 12.9L7.5 10.7L10.6 10.3L12 7.5Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyBadge);
export default __webpack_public_path__ + "static/media/loyalty-badge.3db05a4c173829fb51ce97a5ba656b01.svg";
export { ForwardRef as ReactComponent };